<div class="interiorWrap">

    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="articleHeading">
                    <h1 class="articleHeader">
                        {{article.title}}
                    </h1>
                    <div class="articleMeta">{{article.memberName}} | {{article.dateString}}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="heroSection heroArticle">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div *ngIf="article.imageUrl != ''" class="card articleImgCard" style="background-image: url({{article.imageUrl}});"></div>
                    <div *ngIf="article.imageUrl == ''" class="card articleImgCard" style="background-image: url('../../assets/images/member_news_default.png');"></div>
                </div>
            </div>
        </div>
    </div>

    

    <section class="page-container">

        <div class="container">

            <div class="row">

                <div class="col-md-8">
                    <div class="articleContent">
                        <div [innerHTML]="safeArticleContent"></div>
                    </div>
                    <div class="supportingFiles mt-4">
                        <div class="moreArticlesHeading">
                            <h3>Supporting Files</h3>
                            <div class="styledUnderline"></div>
                        </div>
                        <div class="attachmentBlock" *ngFor="let attachment of article.attachments; index as ind" (click)="DownloadAttachment(ind)">
                            <div class="fileType">
                                <i class="fa-regular" [ngClass]="CommonLibrary.GetFileIconClass(attachment.type)"></i>
                            </div>
                            <div class="fileInfo">
                                <a href="javascript:void(0)" title="download a supporting file" class="fileTitle">
                                    {{attachment.name}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4">

                    <div class="moreArticlesHeading">
                        <h3>MORE FROM {{article.memberName}}</h3>
                        <div class="styledUnderline"></div>
                    </div>

                    <div class="newsListWrap articleNewsList mt-4 row row-cols-1 row-cols-xl-1 row-cols-lg-1 row-cols-md-1 row-cols-sm-1 g-4">

                        <div *ngFor="let art of additionalArticles" class="col">
                            <div class="articleCard card h-100" [routerLink]="['/public/member-news/article', art.articleId]">
                                <div *ngIf="art.imageUrl != ''" class="articleImg" style="background-image: url({{art.imageUrl}});"></div>
                                <div *ngIf="art.imageUrl == ''" class="articleImg" style="background-image: url('../../assets/images/member_news_default.png');"></div>
                                <div class="articleDate">
                                    {{art.dateString}}
                                </div>
                                <div class="articleTitle">
                                    {{art.articleTitle}}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            
        </div>

        

    </section>
</div>
